
enum MarketRegionStateCluster {
	VERY_LOW = 'VERY_LOW', LOW = 'LOW', NORMAL = 'NORMAL', MEDIUM = 'MEDIUM', HIGH = 'HIGH', VERY_HIGH='VERY_HIGH'
}

export const marketRegionStateClusterColors = {
	[MarketRegionStateCluster.VERY_LOW]: '#3b82f6',
	[MarketRegionStateCluster.LOW]: '#6366f1',
	[MarketRegionStateCluster.NORMAL]: '#f59e0b',
	[MarketRegionStateCluster.MEDIUM]: '#f59e0b',
	[MarketRegionStateCluster.HIGH]: '#ec4899',
	[MarketRegionStateCluster.VERY_HIGH]: '#ef4444'
}

export const marketRegionStateClusterClasses = {
	[MarketRegionStateCluster.VERY_LOW]: 'text-blue-500',
	[MarketRegionStateCluster.LOW]: 'text-indigo-500',
	[MarketRegionStateCluster.NORMAL]: 'text-amber-500',
	[MarketRegionStateCluster.MEDIUM]: 'text-amber-500',
	[MarketRegionStateCluster.HIGH]: 'text-pink-500',
	[MarketRegionStateCluster.VERY_HIGH]: 'text-red-500'
}

export const marketRegionStateClusterBgClasses = {
	[MarketRegionStateCluster.VERY_LOW]: 'bg-blue-500',
	[MarketRegionStateCluster.LOW]: 'bg-indigo-500',
	[MarketRegionStateCluster.NORMAL]: 'bg-amber-500',
	[MarketRegionStateCluster.MEDIUM]: 'bg-amber-500',
	[MarketRegionStateCluster.HIGH]: 'bg-pink-500',
	[MarketRegionStateCluster.VERY_HIGH]: 'bg-red-500'
}

export const marketRegionStateClusterNames = {
	[MarketRegionStateCluster.VERY_LOW]: 'Very Low',
	[MarketRegionStateCluster.LOW]: 'Low',
	[MarketRegionStateCluster.NORMAL]: 'Normal',
	[MarketRegionStateCluster.MEDIUM]: 'Medium',
	[MarketRegionStateCluster.HIGH]: 'High',
	[MarketRegionStateCluster.VERY_HIGH]: 'Very High'
}

export default MarketRegionStateCluster;